import OutOfServiceHospital from '@/Classes/800/OutOfServiceHospital';
import AdmissionMissionClass from '@/Classes/Admission/AdmissionMissionsClass';
import Vue from 'vue';
export default {
  data() {
    return {
      confimType: '',
      disabelConfirm: false,
      //top list
      admissionTopListTableHeader: [
        {
          text: '#',
          value: 'icon',
          align: 'center',
          width: 20,
          sortable: false,
          isActive: true
        },
        { text: 'شهر', value: 'city', align: 'center', width: 90, isActive: true },
        { text: 'آدرس', value: 'address', align: 'center', width: 400, isActive: true },
        {
          text: 'کد آمبولانس',
          value: 'ambulanceCode',
          align: 'center',
          width: 110,
          isActive: true
        },
        {
          text: 'وضعیت کد',
          value: 'codeStatus',
          align: 'center',
          width: 180,
          isActive: true
        },
        // { text: 'شبرنگ', value: 'shabrang', align: 'center', width: '130px' },
        { text: 'شکایت اصلی', value: 'cc', align: 'center', width: 180, isActive: true },
        {
          text: 'بیمارستان',
          value: 'hospital',
          align: 'center',
          width: 130,
          isActive: true
        },
        {
          text: 'وضعیت ماموریت',
          value: 'missionStatus',
          align: 'center',
          width: 180,
          isActive: true
        },
        {
          text: 'تشخیص',
          value: 'cheifComplaint',
          align: 'center',
          width: 180,
          isActive: true
        },
        {
          text: 'شماره تماس کد',
          value: 'phoneNumber',
          align: 'center',
          width: 200,
          isActive: true
        },
      ],
      admissionTopList: [],
      currentMissionSearchText: '',
      //stay
      stayInHospitalListTableHeader: [
        { text: 'کد آمبولانس', value: 'ambulanceCode', align: 'center' },
        { text: 'مدت زمان ماندگاری', value: 'time', align: 'center' },
      ],
      stayInHospitalList: [],
      stayInHospitalSearchText: '',
      //hospital
      hospitalListTableHeader: [
        {
          text: 'بیمارستان',
          value: 'hospital',
          align: 'center',
          width: '100px',
        },
        {
          text: 'پذیرش جاری',
          value: 'admissionCount',
          align: 'center',
          width: '100px',
        },
        {
          text: 'پذیرش شیفت روز',
          value: 'admissionCount24',
          align: 'center',
          width: '150px',
        },
        {
          text: 'شماره تماس',
          value: 'phoneNumber',
          align: 'center',
          width: '90px',
        },
      ],
      hospitalList: [],
      hospitalLoader: false,
      hospitalSearchText: '',
      //outOfService
      outOfServiceListTableHeader: [
        {
          text: 'بیمارستان',
          value: 'hospital',
          align: 'center',
          width: '100px',
        },
        { text: 'مدت زمان', value: 'duration', align: 'center', width: '90px' },
        { text: 'کاربر', value: 'user', align: 'center', width: '140px' },
        {
          text: 'شماره تماس',
          value: 'phoneNumber',
          align: 'center',
          width: '100px',
        },
        {
          text: 'توضیحات',
          value: 'note',
          align: 'center',
          width: '100px',
        },
        {
          text: 'عملیات',
          value: 'actions',
          sortable: false,
          align: 'center',
          width: '120px',
        },
      ],
      outOfServiceSearchText: '',
      outOfServiceLoader: false,
      outOfServiceHospitalHour: null,
      outOfServiceHospitalMinute: null,
      outOfServiceHospital: new OutOfServiceHospital.OutOfServiceHospital('', null, null, false),
      addOutOfServiceModal: false,
      //extend
      extendTimeModal: false,
      editNotemodal: false,
      extendHour: null,
      extendMinute: null,
      notReason: null,
      outOfServiceHosspitalId: null,
      outOfServiceMoreInfoModal: false,
      outOfServiceMoreInfoNote: '',
      outOfServiceMoreInfoHospital: '',
      outOfServiceMoreInfoUser: '',
      //send modal
      missionSendToHospitalInfo: new AdmissionMissionClass.MissionSendToHospitalInfo(
        '',
        null,
        '',
        '',
        '',
        '',
        '',
        '',
        '',
      ),
      sendToHospitalModal: false,
      selectedHospital: null,
      selectedTagsList: [],
      selectedtag: null,
      missionPhoneId: null,
      topNearestLoaderFlag: false,
      topNearestDignosisLoaderFlag: false,
      topNearestHospitalList: [],
      nearestDignosisHospitalList: [],
      missionId: null,
      missionPhoneCode: null,
      phoneCode: null,
      phoneId: null,
      mapMovingIconInterval: null,
      hospitalIcon: null,
      allMapHospitals: [],
      missionStatus: '',
      missionRankIconClass: '',
      missionRankIconColor: '',
      hasHospital: false,
      changeHospitalNote: '',
      changeHospitalNoteModal: false,
      lastHospital: null,
      cancelReasonHospitalNote: '',
      cancelReasonHospitalModal: false,
      sendToHospitalTab: 'info',
      sendModalInfoTabClass: 'modal-active-tab',
      sendModalNoteTabClass: 'modal-deactive-tab',
      noteList: [],
      disabelNoteConfirm: false,
      noteText: '',
      //right click
      codePhoneNumbers: [],
      hospitalPhoneNumbers_mission: [],
      rightClickItems: [
        { title: 'تماس با کد', icon: 'mdi-phone-log mdi-flip-h mdi-18px' },
        { title: 'تماس با بیمارستان', icon: 'mdi-hospital-building mdi-18px' },
        { title: 'تماس داخلی', icon: 'mdi-phone-log mdi-flip-h mdi-18px' },
        { title: 'تماس خارجی', icon: 'mdi-phone-forward mdi-flip-h mdi-18px' },
        { title: 'تماس با مددجو', icon: 'mdi-card-account-phone mdi-18px' },
      ],
      patientPhoneNumbers: [],
      iternalPhoneNumber: '',
      externalPhoneNumber: '',
      showMenu: false,
      x: 0,
      y: 0,
      closeOnContentClick: false,
      hospitalPhoneNumbers: [],
      rightClickItems1: [
        {
          title: 'تماس با بیمارستان',
          icon: 'mdi-phone-log mdi-flip-h mdi-18px',
        },
      ],
      showMenu1: false,
      x1: 0,
      y1: 0,
      closeOnContentClick1: false,
      rightClickItems2: [
        {
          title: 'تماس با بیمارستان',
          icon: 'mdi-phone-log mdi-flip-h mdi-18px',
        },
      ],
      showMenu2: false,
      x2: 0,
      y2: 0,
      closeOnContentClick2: false,
    };
  },
  methods: {
    refreshManual: function (type) {
      if (type == 'topList') {
        this.getListOfCurrentMissionsForAdmissionFunction();
      } else if (type == 'hospital') {
        this.hospitalList = [];
        this.getListOfHospitalsForAdMissionFunction();
      } else if (type == 'outOfService') {
        this.getListOfAllActiveOutOfServiceHospitalsFunction();
        // this.getListOfAllActiveAlarmOutOfServiceHospitalsFunction();
      }
    },
    // ******** hospital *******************
    readyHospitalTableData: function (data) {
      this.hospitalList = [];
      for (let i = 0; i < data.length; i++) {
        let hospitalPhoneNumbers = [];
        let tmpPhoneNumber = data[i].phoneNumber.split(',');
        for (let j = 0; j < tmpPhoneNumber.length; j++) {
          if (tmpPhoneNumber[j] && tmpPhoneNumber[j] != ',') {
            hospitalPhoneNumbers.push(tmpPhoneNumber[j]);
          }
        }
        this.hospitalList.push({
          id: data[i].id,
          hospital: data[i].title ? data[i].title : '-',
          phoneNumber: data[i].phoneNumber ? data[i].phoneNumber : '-',
          admissionCount: data[i].recentAdmissionCount ? data[i].recentAdmissionCount : '0',
          admissionCount24: data[i].last24HoursAdmissionCount
            ? data[i].last24HoursAdmissionCount
            : '0',
          hospitalPhoneNumbers: hospitalPhoneNumbers,
        });
      }
      this.hospitalLoader = false;
    },
    removeHospital: function () {
      this.removeHospitalFunction(this.cancelReasonHospitalNote, this.missionPhoneId);
    },
    //times
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
    //out of service part
    enableAddOutOfServiceFunction: function () {
      this.getListOfAllActiveHospitalsFunction();
      this.confimType = 'addOutOfService';
      this.addOutOfServiceModal = true;
    },
    cancelAddOutOfServiceFunction: function () {
      this.outOfServiceHospital = new OutOfServiceHospital.OutOfServiceHospital('', null, null, false);
      this.outOfServiceHospitalHour = null;
      this.outOfServiceHospitalMinute = null;
      this.addOutOfServiceModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'addOutOfService') {
        this.addOutOfServiceHospitalFunction();
      } else if (this.confimType == 'extendOutOfService') {
        this.$refs.confirm.title = 'تمدید زمان';
        this.$refs.confirm.text = 'از تمدید زمان اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'endOutOfService') {
        this.$refs.confirm.title = 'تغییر وضعیت';
        this.$refs.confirm.text = 'از تغییر وضعیت اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'addOutOfService') {
        this.disabelConfirm = true;
        this.addOutOfServiceHospitalFunction();
      } else if (this.confimType == 'extendOutOfService') {
        this.disabelConfirm = true;
        this.extendOutOfServiceHospitalFunction();
      } else if (this.confimType == 'endOutOfService') {
        this.disabelConfirm = true;
        this.endOutOfServiceHospitalFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'addOutOfService') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'extendOutOfService') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'endOutOfService') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    // end
    showEndConfirmFunction: function (id) {
      this.outOfServiceHospitalId = id;
      this.confimType = 'endOutOfService';
      this.showConfirmDialogFunction();
    },
    //sendToHospitalModal
    closeEditModal: function () {
      this.cleanForm()
    },
    // extends
    showExtendTimeModal: function (id) {
      this.outOfServiceHospitalId = id;
      this.confimType = 'extendOutOfService';
      this.extendTimeModal = true;
    },
    cancelExtendTimetFunction: function () {
      this.extendHour = null;
      this.extendMinute = null;
      this.extendTimeModal = false;
    },
    //editNotemodal
    showEditNoteModal: function (item) {
      this.notReason = item?.note;
      this.outOfServiceHospitalId = item?.id;
      this.editNotemodal = true;
    },
    cancelEditNoteFunction: function () {
      this.notReason = null;
      this.editNotemodal = false;
    },
    showOutOfServiceMoreInfoModal: function (data) {
      this.outOfServiceMoreInfoNote = data.note;
      this.outOfServiceMoreInfoHospital = data.hospital;
      this.outOfServiceMoreInfoUser = data.user;
      this.outOfServiceMoreInfoModal = true;
    },
    closeOutOfServiceMoreInfo: function () {
      this.outOfServiceMoreInfoNote = '';
      this.outOfServiceMoreInfoHospital = '';
      this.outOfServiceMoreInfoUser = '';
      this.outOfServiceMoreInfoModal = false;
    },
    //send to hospital
    showSendToHospitalModal: function (value, data) {
      this.missionPhoneId = data.item.id;
      this.missionId = data.item.missionId;
      this.missionPhoneCode = data.item.ambulanceCode;
      this.phoneCode = data.item.ambulanceCode;
      this.phoneId = data.item.phoneId;
      this.missionStatus = data.item.missionStatus;
      this.getMissionForAssignHospitalFunction();
      this.getListOfTagsForOther();
      this.getListOfAllActiveHospitalsFunction();
      this.getListOfHospitalsForOther();
      this.getPhoneOnlineLocationFunction(data.item.phoneId);
      this.sendToHospitalModal = true;
      this.mapMovingIconInterval = setInterval(() => {
        this.getPhoneOnlineLocationFunction(data.item.phoneId);
      }, 4000);
    },
    add800SelectedMarker: function (event) {
      this.selected800Position = event.latlng;
    },
    selectHospitalFromAdvice: function (data) {
      this.selectedHospital = data.id;
    },
    addMissionTag: function () {
      if (this.selectedtag) {
        let flag = false;
        if (this.selectedTagsList.length > 0) {
          for (let i = 0; i < this.selectedTagsList.length; i++) {
            if (this.selectedTagsList[i].id == this.selectedtag) {
              flag = true;
            }
          }
        }
        if (flag == false) {
          this.addToMissionTagByAdmissionFunction(this.missionId, this.selectedtag);
        } else {
          this.snackText = 'برچسب قبلا اضافه شده است';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
        }
      } else {
        this.snackText = 'لطفا برچسب را انتخاب نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
      }
    },
    readyMapHopitalLocations: function () {
      this.allMapHospitals = [];
      for (let i = 0; i < this.allHospitalsForOther.length; i++) {
        if (this.allHospitalsForOther[i].latitude) {
          this.allMapHospitals.push({
            lat: this.allHospitalsForOther[i].latitude,
            lng: this.allHospitalsForOther[i].longitude,
            title: this.allHospitalsForOther[i].title,
            id: this.allHospitalsForOther[i].id,
          });
        }
      }
    },
    setHospital: function () {
      if (!this.selectedHospital) {
        this.snackText = 'بیمارستان را انتخاب نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.hasHospital == true) {
        //most get note change hopital
        if (this.selectedHospital == this.lastHospital) {
          this.snackText = 'بیمارستان مورد نظر برای ماموریت قبلا انتخاب شده است';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
        this.changeHospitalNote = '';
        this.changeHospitalNoteModal = true;
      } else {
        this.sendMissionToHospitalFunction();
      }
    },
    cleanForm: function () {
      this.missionSendToHospitalInfo = new AdmissionMissionClass.MissionSendToHospitalInfo(
        '',
        null,
        '',
        '',
        '',
        '',
        '',
        '',
        '',
      );
      this.selectedHospital = null;
      this.selectedTagsList = [];
      this.selectedtag = null;
      this.missionPhoneId = null;
      this.topNearestLoaderFlag = false;
      this.topNearestDignosisLoaderFlag = false;
      this.topNearestHospitalList = [];
      this.nearestDignosisHospitalList = [];
      this.missionId = null;
      clearInterval(this.mapMovingIconInterval);
      this.mapMovingIconInterval = null;
      this.allMapHospitals = [];
      this.missionStatus = '';
      this.missionRankIconClass = '';
      this.missionRankIconColor = '';
      this.hasHospital = false;
      this.changeHospitalNote = '';
      this.lastHospital = null;
      this.cancelReasonHospitalNote = '';
      this.noteList = [];
      this.sendToHospitalTab = 'info';
      this.sendModalInfoTabClass = 'modal-active-tab';
      this.sendModalNoteTabClass = 'modal-deactive-tab';
      this.disabelNoteConfirm = false;
      this.noteText = '';
      this.changeHospitalNoteModal = false;
      this.sendToHospitalModal = false;
    },
    setChangeHospital: function () {
      if (!this.changeHospitalNote) {
        this.snackText = 'توضیحات را وارد نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.changeHospitalNote.replace(/\s/g, '').length) {
        this.snackText = 'توضیحات را وارد نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      this.sendMissionToHospitalFunction();
    },
    cancleChangeHospital: function () {
      this.changeHospitalNote = '';
      this.changeHospitalNoteModal = false;
    },
    setRemoveHospital: function () {
      this.cancelReasonHospitalNote = '';
      this.cancelReasonHospitalModal = true;
    },
    cancleCancleResoneHospital: function () {
      this.cancelReasonHospitalNote = '';
      this.cancelReasonHospitalModal = false;
    },
    changeSendModalTab: function (type) {
      if (type == 'info') {
        this.sendModalInfoTabClass = 'modal-active-tab';
        this.sendModalNoteTabClass = 'modal-deactive-tab';
        this.sendToHospitalTab = 'info';
      } else if (type == 'note') {
        this.noteText = '';
        this.getAllMissionNoteFunction(this.missionId, this.missionPhoneId);
        this.sendModalNoteTabClass = 'modal-active-tab';
        this.sendModalInfoTabClass = 'modal-deactive-tab';
        this.sendToHospitalTab = 'note';
      }
    },
    //note tab
    readyNoteData: function (data) {
      this.noteList = [];
      for (let i = 0; i < data.length; i++) {
        let user = '';
        let date = '';
        if (data[i].user) {
          let fName = data[i].user.firstName ? data[i].user.firstName : '-';
          let lName = data[i].user.lastName ? data[i].user.lastName : '-';
          user = fName + ' ' + lName;
        }
        if (data[i].noteDate) {
          date = Vue.moment(data[i].noteDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        this.noteList.push({
          user: user,
          date: date,
          note: data[i].note ? data[i].note : '-',
          id: data[i].id,
        });
      }
    },
    noteHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.addNote();
      }
    },
    addNote: function () {
      this.disabelNoteConfirm = true;
      if (!this.noteText) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelNoteConfirm = false;
        return;
      }
      if (!this.noteText.replace(/\s/g, '').length) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelNoteConfirm = false;
        return;
      }
      this.addNoteToMissionFucntion(this.noteText, this.missionId, this.missionPhoneId);
    },
    callToPatient: function (number) {
      if (number && number != '-') {
        let data = {
          missionId: this.missionId,
          missionPhoneId: this.missionPhoneId,
          to: number,
        };
        this.callToPatientFunction(data);
      }
    },
    //right click
    rightClickHandler(e, data) {
      e.preventDefault();
      this.hospitalPhoneNumbers_mission = data.item.hospitalPhoneNumber_mission;
      this.codePhoneNumbers = data.item.codePhoneNumbers;
      this.patientPhoneNumbers = data.item.patiantPhoneNumbers;
      this.missionPhoneId = data.item.id;
      this.missionId = data.item.missionId;
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    rightClickAction: function (type, to) {
      this.showMenu = false;
      if (type == 'تماس با کد') {
        if (to) {
          let data = {
            missionPhoneId: this.missionPhoneId,
            missionId: this.missionId,
            to: to,
          };
          this.callToCodeFunction(data);
          this.showMenu = false;
        } else {
          this.snackText = 'کد شماره ثبت شده ای ندارد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      } else if (type === 'تماس با بیمارستان') {
        if (to) {
          let data = {
            missionPhoneId: this.missionPhoneId,
            missionId: this.missionId,
            to: to,
          };
          this.callToHospitalFunction(data);
          this.showMenu = false;
        } else {
          this.snackText = 'شماره تماس را وارد نمایید';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      } else if (type == 'تماس با مددجو') {
        if (to) {
          let data = {
            missionPhoneId: this.missionPhoneId,
            missionId: this.missionId,
            to: to,
          };
          this.callToPatientFunction(data);
          this.showMenu = false;
        }
      } else if (type == 'تماس داخلی') {
        if (this.iternalPhoneNumber) {
          let data = {
            missionPhoneId: this.missionPhoneId,
            missionId: this.missionId,
            to: this.iternalPhoneNumber,
          };
          this.callToInternalFunction(data);
          this.iternalPhoneNumber = '';
          this.showMenu = false;
        } else {
          this.snackText = 'شماره تماس را وارد نمایید';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      } else if (type === 'تماس خارجی') {
        if (this.externalPhoneNumber) {
          let data = {
            missionPhoneId: this.missionPhoneId,
            missionId: this.missionId,
            to: this.externalPhoneNumber,
          };
          this.callToCustomNumber(data);
          this.externalPhoneNumber = '';
          this.showMenu = false;
        } else {
          this.snackText = 'شماره تماس را وارد نمایید';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      }
    },
    rightClickHandler1(e, data) {
      e.preventDefault();
      this.hospitalPhoneNumbers = data.item.hospitalPhoneNumbers;
      this.showMenu1 = false;
      this.x1 = e.clientX;
      this.y1 = e.clientY;
      this.$nextTick(() => {
        this.showMenu1 = true;
      });
    },
    rightClickAction1: function (type, to) {
      if (type == 'تماس با بیمارستان') {
        if (to) {
          let data = {
            missionPhoneId: null,
            missionId: null,
            to: to,
          };
          this.callToHospitalFunction(data);
        } else {
          this.snackText = 'بیمارستان شماره ثبت شده ای ندارد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      }
    },
    rightClickHandler2(e, data) {
      e.preventDefault();
      this.hospitalPhoneNumbers = data.item.hospitalPhoneNumbers;
      this.showMenu2 = false;
      this.x2 = e.clientX;
      this.y2 = e.clientY;
      this.$nextTick(() => {
        this.showMenu2 = true;
      });
    },
    rightClickAction2: function (type, to) {
      if (type == 'تماس با بیمارستان') {
        if (to) {
          let data = {
            missionPhoneId: null,
            missionId: null,
            to: to,
          };
          this.callToHospitalFunction(data);
        } else {
          this.snackText = 'بیمارستان شماره ثبت شده ای ندارد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      }
    },
  },
};
